import BookmarkIcon from '@mui/icons-material/Bookmark'
import BookmarkBorder from '@mui/icons-material/BookmarkBorder'
import Button from '@mui/material/Button'

import useBookmarks from '../../utils/hooks/useBookmarks'

const Bookmark = ({ type, id, displayName }: { type: 'account'; id: string | number; displayName: string }) => {
  const { isBookmarked, saveToBookmarks, removeFromBookmarks } = useBookmarks()

  return (
    <>
      {isBookmarked(type, id) ? (
        <Button endIcon={<BookmarkIcon />} onClick={() => removeFromBookmarks('account', id)}>
          Saved
        </Button>
      ) : (
        <Button
          endIcon={<BookmarkBorder />}
          onClick={() =>
            saveToBookmarks('account', id, {
              displayName,
            })
          }
        >
          Save
        </Button>
      )}
    </>
  )
}

export default Bookmark
